<template>
    <div class="results">
        <div class="imgs"><img src="../assets/image/404.png" /></div>
        <div class="tips">{{$t('result.errorTips')}}</div>
        <div>
            <mu-button color="success" @click="closePage">{{$t('result.closePage')}}</mu-button>
        </div>
    </div>
</template>

<script>
    import preventBack from 'vue-prevent-browser-back';
    export default {
        mixins: [preventBack],
        data() {
            return {

            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            closePage() {
                window.opener = null;
                window.open("about:blank", "_top").close()
            }
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    .results {
        margin: 0 auto;
        width: 100%;
        text-align: center;
        margin-top: 50px
    }

        .results imgs {
            text-align: center;
        }

        .results img {
            width: 100px;
            height: 100px;
        }

        .results .tips {
            padding: 20px;
            font-size: 16px;
        }
</style>



// WEBPACK FOOTER //
// src/components/Error.vue